import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useEffect, useState } from 'react';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { addCategoryOrdering, orderingCategorySelector } from 'rahtab-redux/slices/categoryOrderingSlice';
import { addCategory } from 'rahtab-redux/slices/categoriesSlice';

function useCategories() {
  const dispatch = useAppDispatch();
  const [idList, setIdList] = useState<Set<string> | undefined>();
  const categories = useSelector(orderingCategorySelector(Array.from(idList?.values() || [])));
  const [refetch, { called, loading, data }] = useFetchCallType<OfferProductInfo[]>('GetOfferProductList', {
    onCompleted: (d) => {
      let temp = new Set(idList);
      d.forEach((category) => {
        temp.add(category.ProductCode);
        dispatch(addCategoryOrdering(category));
        dispatch(addCategory(category));
      });
      setIdList(temp);
    },
  });

  return {
    loading,
    called,
    data: categories,
    refetch,
  };
}
export default useCategories;

export interface OfferProductInfo {
  ProductCode: string;
  ProductName: string;
  ProductImage: string;
  OfferSupplierCount: string;
  OfferTemplateCount: string;
  RemainingValues: number;
  Status: string;
  StatusCode: number;
}
